import CustomAudioPlayer from "./customAudioPlayer";

export const customAudioPlayerInit = (function ($) {

    function init() {
        CustomAudioPlayer.init({
            selector: '.player',
            stopOthersOnPlay: true,
            // showProgressBar: true,
            // showVolumeButton: true,
            // showDownloadButton: true,
            // enableKeystrokes: true,
            // showTooltips: true
        });
    }

    return {
        init: init
    }

})(jQuery);